module.exports = __webpack_public_path__ + "img/20wjhz-doc.8193212e.svg";